/*** Combine all reducers in this file and export the combined reducers ***/

import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import history from "./utils/history";
import conceptReducer from "./store/Concept/reducer";
import userReducer from "./store/Users/reducer";
import generalReducer from "./store/General/reducer";

/*** Merges the main reducer with the router state and dynamically injected reducers ***/

export default function createReducer(injectedReducers = {}) {
  const rootReducer = combineReducers({
    concept: conceptReducer,
    router: connectRouter(history),
    user: userReducer,
    general: generalReducer,
    ...injectedReducers,
  });

  return rootReducer;
}
